<template>
  <div class="upload-content">
    <div class="clearfix mb-3">
      <div class="float-end d-flex">
        <McButton
          class="upload-content__btn-next"
          :text="$t('global.next')"
          icon="icon-outline_arrow-right"
          iconPosition="right"
          :disabled="isDisableNextBtn || isLoading"
          @click="handleProcessFileSetToCustomer"
        >
          <b-spinner v-if="isLoading" small class="mr-2" />
        </McButton>
      </div>
    </div>

    <b-card class="upload-card">
      <b-row>
        <b-col cols="4">
          <AttachmentField
            @update:isDisableNextBtn="isDisableNextBtn = $event"
            @file-selected="handleFileSelected"
          />
        </b-col>

        <b-col cols="8" class="d-flex">
          <GuideCard :isSetTo="isSetTo" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import AttachmentField from '../components/AttachmentField'
import GuideCard from '../components/GuideCard'
import * as importJobsApi from '@/services/rest-api-sms/lib/import-jobs/import-jobs'

export default {
  components: {
    McButton,
    AttachmentField,
    GuideCard,
  },

  data() {
    return {
      selectedFile: null,
      isDisableNextBtn: true,
      isSetTo: true,
      isLoading: false,
    }
  },

  methods: {
    handleFileSelected(file) {
      this.selectedFile = file
    },

    async handleProcessFileSetToCustomer() {
      if (!this.selectedFile) {
        this.$toast.warning('Silakan pilih file terlebih dahulu')
        return
      }

      this.isLoading = true

      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)
        formData.append('module', 'assign_device')

        const res = await importJobsApi.upload(formData)

        this.$router.push({
          name: 'Device Import Set To Customer Process',
          params: {
            jobId: res?.data.id,
          },
        })
      } catch (error) {
        this.$toast.error('Upload gagal. Silakan coba lagi.')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-card {
  .card-body {
    padding: 24px;
  }
}
</style>
